import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Grid, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Button from "components/CustomButton/CustomButton.jsx";
import { setMessage } from "../../../../redux/actions/status";
import ClassePharmacologique from './ClasseForm';

class ClasseResult extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            vSubstanceClasse: '',
            vClasse: '',
            nomSubstance: '',
            result: {
                status:null,
                data:"Après avoir selectionner vos données appuyer sur le button ci-dessous pour lancer l&apos;analyse "
            }
        }
    }
    onChangeClasse = classe => {
        this.setState({ vClasse: classe.value.toLowerCase() });
    }

    onChangeSubstance = substance => {
        
        if(substance.classesContresIndiquees== undefined){
            substance.classesContresIndiquees =''
        }
        if(substance.classesContresIndiquees.includes(',')){
            this.setState({
                vSubstanceClasse: substance.classesContresIndiquees.split(","),
                nomSubstance: substance.label.toUpperCase()
            });
        }
        else{
            this.setState({
                vSubstanceClasse: substance.classesContresIndiquees,
                nomSubstance: substance.label.toUpperCase()
            });
        }
        }

    onSubmit(event) {
        event.preventDefault();
        const vClasse = this.state.vClasse.toLowerCase();
        if(this.state.nomSubstance==''||this.state.vClasse == ''){
            this.setState({result: {status:0, data:"VEUILLEZ SELECTIONNER LES DONNEES A ANALYSER !"}});
            this.props.setMessage({ message: "Champ vide !", status: "danger" });
        }
        else if(this.state.vSubstanceClasse.indexOf(this.state.vClasse) != -1){
            this.setState({result: {status:1, data:"< "+this.state.nomSubstance+" > "+" est contre-indiquée en association avec : "+"< "+this.state.vClasse.toUpperCase()+" >"}});
            this.props.setMessage({ message: "< "+this.state.nomSubstance+" > "+" est contre-indiquée en association avec: "+"< "+this.state.vClasse.toUpperCase()+" >", status: "warning" });
        } else{
            this.setState({result: {status:-1, data:"< "+this.state.nomSubstance+" > "+" n&apos;est pas contre-indiquée en association avec : "+"< "+this.state.vClasse.toUpperCase()+" >"}});
            this.props.setMessage({ message: "< "+this.state.nomSubstance+" > "+" n&apos;est pas contre-indiquée en association avec : "+"< "+this.state.vClasse.toUpperCase()+" >", status: "success" });
        }  
       
    }
    
    render() {
        return (
            <div className="main-content" >
                <Grid fluid>
                <Row>
                    <Col md={12} style={{ marginBottom: "16px" }}>
                        <Link to="/app/analyse/analyses">
                            <Button bsStyle="default" fill bsSize="lg">
                                Retour
                            </Button>
                        </Link>
                    </Col>
                </Row>
                    <Col sm={12}>
                        <form onSubmit={this.onSubmit}>
                            <ClassePharmacologique
                                onChangeSubstance = {this.onChangeSubstance}
                                onChangeClasse = {this.onChangeClasse}
                                result={this.state.result}
                            />
                        </form>
                    </Col>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        substance: state.substances.substance,        
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setMessage: (message) => {
            dispatch(setMessage(message));
        }
    }
};
  
ClasseResult.propTypes = {
    match: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    setMessage: PropTypes.func,
    Substance: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClasseResult);